import ActionTypes from '../actions/types';
import { setState, setObjectToState } from './helper';
import { defaultState } from './defaultState';
/*eslint no-case-declarations: 0 */

const initialState = defaultState.checkout;

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_CHECKOUT_DATA:
      return setObjectToState(state, {
        spotToReserve: action.spotToReserve,
        spotToUnreserve: action.spotToUnreserve
      });

    case ActionTypes.UPDATE_CHECKOUT_SPOT_TO_REMOVE:
      return setState(state, action, 'spotToUnreserve');

    case ActionTypes.UPDATE_TIMESTAMP:
      const newTimeStamp = action.timeStamp > 0 ? action.timeStamp : 0;
      return setState(state, {timeStamp: newTimeStamp}, 'timeStamp');

    case ActionTypes.TOGGLE_BACKEND_RELASE_SPOT_FLAG:
      return setState(state, action, 'isBackendRelasedSpot');

    case ActionTypes.SET_REQUEST_ID:
      return setState(state, action, 'requestId');

    case ActionTypes.SET_CHECKOUT_EVENT:
      return setState(state, action, 'event');

    case ActionTypes.SET_CHECKOUT_LOADER:
      return setState(state, {isLoading: true}, 'isLoading');

    case ActionTypes.RESET_CHECKOUT_LOADER:
      return setState(state, {isLoading: false}, 'isLoading');

    case ActionTypes.RESET_CHECKOUT_DATA:
      return initialState;

    default:
      return state;
  }

};



// WEBPACK FOOTER //
// ./src/reducers/checkoutReducer.js